//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const ChangePassword = createAsyncThunk(
  "ChangePassword",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingChangePassword(""));
      const response = await UsePortalApi(
        `Patient/ChangePassword`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
      dispatch(gettingChangePasswordSuccess(response)) 

      } else {
        dispatch(
          gettingChangePasswordFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingChangePasswordFailed(error));
    }
  }
);
const ChangePasswordSlice = createSlice({
  name: "ChangePassword",
  initialState: {
    ChangePasswordData: null,
    isChangePasswordLoading: false,
    isChangePasswordError: false,
  },
  reducers: {
    gettingChangePassword: (state, action) => {
      state.ChangePasswordData = null;
      state.isChangePasswordLoading = true;
      state.isChangePasswordError = false;
    },
    gettingChangePasswordSuccess: (state, action) => {
      state.ChangePasswordData = action.payload;
      state.isChangePasswordLoading = false;
      state.isChangePasswordError = false;
    },
    gettingChangePasswordFailed: (state, action) => {
      state.ChangePasswordData = null;
      state.isChangePasswordLoading = false;
      state.isChangePasswordError = true;
    },
    gettingChangePasswordClear: (state, action) => {
      state.ChangePasswordData = null;
      state.isChangePasswordLoading = false;
      state.isChangePasswordError = false;
    },
  },
});
export const {
  gettingChangePassword,
  gettingChangePasswordSuccess,
  gettingChangePasswordFailed,
  gettingChangePasswordClear,
} = ChangePasswordSlice.actions;
export default ChangePasswordSlice.reducer;
